import { useTypesStore } from '../store/Types';
import { useTypesRender } from '../utils/useRender';
export var Int = props => {
  var {
    Int: Comp = {}
  } = useTypesStore();
  useTypesRender(Comp, props, 'Int');
  return null;
};
Int.displayName = 'JVR.Int';